import * as yup from "yup";

const userDataSchema = yup.object({
  firstName: yup.string().max(200).required(),
  lastName: yup.string().max(200).required(),
  phone: yup.number().required()
}).required();

export default userDataSchema;
